import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export default function StoreQr({ store, url, miles = 25, hours = 2 }) {
  const ref = useRef(null);

  const print = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const png = canvas.toDataURL("image/png");
    const w = window.open("", "_blank", "width=720,height=900");
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>${store.name} · Harvey's Place delivery QR</title>
<style>
  @page { size: letter; margin: 0.6in; }
  body { font-family: Arial, Helvetica, sans-serif; color: #0C2E2B; text-align: center; margin: 0; padding: 32px; }
  .card { border: 6px solid #0C2E2B; border-radius: 24px; padding: 40px 32px; max-width: 560px; margin: 0 auto; }
  .kicker { font-size: 13px; letter-spacing: 4px; text-transform: uppercase; font-weight: 800; color: #6b7280; }
  h1 { font-size: 40px; line-height: 1.05; margin: 10px 0 6px; font-weight: 900; }
  h2 { font-size: 20px; margin: 0 0 18px; font-weight: 700; color: #374151; }
  .rate { display: inline-block; background: #FFDF00; padding: 10px 18px; border-radius: 10px; font-weight: 900; font-size: 22px; margin: 8px 0 22px; }
  img { width: 300px; height: 300px; }
  .url { font-family: monospace; font-size: 13px; color: #374151; margin-top: 14px; word-break: break-all; }
  .foot { margin-top: 22px; font-size: 13px; color: #6b7280; }
  .brand { margin-top: 26px; font-weight: 900; font-size: 16px; letter-spacing: 1px; }
</style></head><body>
<div class="card">
  <div class="kicker">Bought it here? We deliver &amp; build it</div>
  <h1>Flat-rate delivery &amp; assembly</h1>
  <h2>${store.name}</h2>
  <div class="rate">$${Number(store.flat_rate).toFixed(0)} within ${miles} miles · up to ${hours} hrs</div>
  <div><img src="${png}" alt="QR code" /></div>
  <div class="url">${url}</div>
  <div class="foot">Scan with your phone camera → pick your items → book &amp; pay in about a minute.<br/>Old furniture hauled away too.</div>
  <div class="brand">HARVEY'S PLACE · harveys-place.com</div>
</div>
<script>window.onload = () => { window.print(); };</script>
</body></html>`);
    w.document.close();
  };

  return (
    <div className="flex items-center gap-2" data-testid={`fd-store-qr-${store.id}`}>
      <div ref={ref} className="bg-white p-1 rounded border border-zinc-200"><QRCodeCanvas value={url} size={56} level="M" fgColor="#0C2E2B" includeMargin={false} /></div>
      <Button type="button" size="sm" variant="outline" className="h-7 text-[11px]" data-testid={`fd-store-qr-print-${store.id}`} onClick={print}><Printer className="w-3 h-3 mr-1" /> Print counter card</Button>
    </div>
  );
}
